import { Button } from "antd";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { SECCION_LABEL } from "../../../utils/auditoriaSecciones";

// AUDITORIA-CLINICA-REDISENO (FASE 1 · columna derecha) -- últimas
// correcciones de la atención. El panel de "Verificación" (checklist) y el de
// "Observación del auditor" de la maqueta NO se implementan: no existe dónde
// persistirlos y la regla de oro prohíbe inventar backend (FASE 0 §6, decisión
// confirmada). Por eso esta columna sólo trae lo que sí es dato real.

const CAMPO_LABEL = {
    motivo: "Motivo",
    enfermedad_actual: "Enfermedad actual",
    plan_tratamiento: "Plan de tratamiento",
    nota_evolucion: "Nota de evolución",
    presion: "Presión",
    pulso: "Pulso",
    temperatura: "Temperatura",
    saturacion_oxigeno: "Saturación O2",
    frecuencia_respiratoria: "Frec. respiratoria",
    peso: "Peso",
    talla: "Talla",
    imc: "IMC",
    perimetro_cefalico: "Perímetro cefálico",
};

const recorta = (v, max = 46) => {
    const texto = v === null || v === undefined || v === "" ? "—" : String(v);
    return texto.length > max ? `${texto.slice(0, max - 1)}…` : texto;
};

const etiquetaDiagnostico = (json) => [json?.codigo, json?.nombre].filter(Boolean).join(" - ") || `CIE #${json?.iddiagnostico ?? "—"}`;

/**
 * Resumen de una línea del cambio, legible -- nunca el JSON crudo.
 * Se apoya en `operation` (ADD/REMOVE/REPLACE/VOID/UPDATE), que el backend ya
 * guarda por detalle en `clinical_audit_correction_details`.
 */
export function resumenCambio(cambio) {
    const antes = cambio?.before_json || null;
    const despues = cambio?.after_json || null;
    switch (cambio?.operation) {
        case "ADD":
            return `Agregado ${etiquetaDiagnostico(despues)}`;
        case "REMOVE":
            return `Retirado ${etiquetaDiagnostico(antes)}`;
        case "REPLACE":
            return `Receta #${antes?.idreceta ?? "—"} sustituida por #${despues?.idreceta ?? "—"}`;
        case "VOID":
            return `Receta #${antes?.idreceta ?? "—"} anulada`;
        default: {
            if (!antes || !despues) return "Cambio registrado";
            const campo = Object.keys(despues).find((k) => JSON.stringify(antes[k]) !== JSON.stringify(despues[k]));
            if (!campo) return "Cambio registrado";
            return `${CAMPO_LABEL[campo] || campo}: ${recorta(antes[campo], 22)} → ${recorta(despues[campo], 22)}`;
        }
    }
}

function AtencionPanelCorrecciones({ cambios, total, onVerHistorial }) {
    return (
        <div className="ac-panel" data-testid="ac-panel-correcciones">
            <span className="ac-panel__titulo">Correcciones ({total})</span>
            {cambios.length === 0 ? (
                <span className="ac-progreso__texto">Esta atención no registra correcciones de auditoría.</span>
            ) : (
                <div>
                    {cambios.map((cambio) => (
                        <div className="ac-correccion" key={cambio.id}>
                            <span className="ac-correccion__seccion">{SECCION_LABEL[cambio.section] || cambio.section}</span>
                            <span className="ac-correccion__cambio">{resumenCambio(cambio)}</span>
                            <span className="ac-correccion__firma">
                                {cambio.actor?.full_name || "Auditor"}
                                {cambio.created_at ? ` · ${format(new Date(cambio.created_at), "dd/MM/yyyy HH:mm", { locale: es })}` : ""}
                            </span>
                        </div>
                    ))}
                </div>
            )}
            {total > 0 && (
                <Button type="link" size="small" className="p-0 text-start" onClick={onVerHistorial}>
                    Ver historial completo
                </Button>
            )}
        </div>
    );
}

export default AtencionPanelCorrecciones;
